import { render, staticRenderFns } from "./snaps.vue?vue&type=template&id=359c3f36&scoped=true&"
import script from "./snaps.vue?vue&type=script&lang=js&"
export * from "./snaps.vue?vue&type=script&lang=js&"
import style0 from "./snaps.vue?vue&type=style&index=0&id=359c3f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c3f36",
  null
  
)

export default component.exports